export const onUpdateCourse = /* GraphQL */ `
  subscription onUpdateCourse {
    onUpdateCourse {
      pricing {
        subscriptions {
          active
          autoRenewal
          period
          price
          stripePriceId
        }
        freeTrial {
          active
          duration
          period
        }
      }
    }
  }
`;

export const onUpdateCourseStatus = /* GraphQL */ `
  subscription onUpdateCourseStatus {
    onUpdateCourse {
      id
      status
    }
  }
`;
